module.exports = __webpack_public_path__ + "img/ok_weixin.208e130e.png";